module.exports = __webpack_public_path__ + "img/triple_crush.cover.743ef02c.jpg";